import { isEnabledFlag } from './locationFleetSettings';

export const DEFAULT_LOCATION_FEATURE_TOGGLES = {
  allowGiftCardManagement: false,
  blockDiscountedGiftCards: false,
  allowLoyaltyPointsManagement: false,
};

export const parseLocationFeatureToggles = (data: any = {}) => ({
  allowGiftCardManagement: isEnabledFlag(data?.isGiftCardEnabled),
  blockDiscountedGiftCards: isEnabledFlag(data?.blockGiftCardWithPromo),
  allowLoyaltyPointsManagement: isEnabledFlag(data?.isLoyaltyEnabled),
});

export const getLocationFeatureRequestFields = (data?: {
  allowGiftCardManagement?: boolean;
  blockDiscountedGiftCards?: boolean;
  allowLoyaltyPointsManagement?: boolean;
} | null) => ({
  isGiftCardEnabled: Boolean(data?.allowGiftCardManagement),
  blockGiftCardWithPromo: Boolean(data?.blockDiscountedGiftCards),
  isLoyaltyEnabled: Boolean(data?.allowLoyaltyPointsManagement),
});
